module.exports = __webpack_public_path__ + "img/img_article5_item_1_v3.5ddf6e30.png";